import { Pipe, PipeTransform, inject } from '@angular/core';
import { AuthService } from '@guard/auth.service';
import { AccessRight } from '@constants/enum';

@Pipe({
  name: 'anyRights',
})
export class AnyRightsPipe implements PipeTransform {
  private readonly authService = inject(AuthService);

  transform(rights: AccessRight[]): boolean {
    return this.authService.hasAnyRights(rights);
  }
}
